var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hotizontal",class:[_vm.$store.state.layout_style, _vm.$store.state.menu_style]},[_c(_vm.layout,{tag:"component"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }